import React from "react";

import { Dashboard } from "../components/dashboard/Dashboard";
import { MainLayout } from "../components/layout/MainLayout";

export const DashboardPage: React.FC = () => {
  return (
    <MainLayout>
      <Dashboard />
    </MainLayout>
  );
};
